module.exports = __webpack_public_path__ + "img/oriental.3ad06414.png";